/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_HintInputs */

const th_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดตามเพื่อรับการแจ้งเตือนเกี่ยวกับเกม`)
};

const en_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow to be notified about games.`)
};

const ja_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォローすると試合の通知が届きます。`)
};

const zh_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关注后可收到比赛消息。`)
};

const es_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sigue para recibir avisos sobre los partidos.`)
};

const pt_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siga para receber avisos sobre os jogos.`)
};

const id_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikuti untuk mendapat kabar tentang pertandingan.`)
};

const fr_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivez pour être prévenu des matchs.`)
};

const tl_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumunod para mabalitaan tungkol sa mga laro.`)
};

const vi_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo dõi để được báo về các trận đấu.`)
};

const ko_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기 소식을 받으려면 팔로우하세요.`)
};

const de_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folge, um über Spiele benachrichtigt zu werden.`)
};

const ru_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подпишитесь, чтобы получать новости о матчах.`)
};

const tr_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maçlardan haberdar olmak için takip edin.`)
};

const it_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segui per ricevere notizie sulle partite.`)
};

const pl_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obserwuj, aby dostawać wiadomości o meczach.`)
};

const uk_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стежте, щоб отримувати новини про матчі.`)
};

const hi_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैचों की जानकारी पाने के लिए फ़ॉलो करें।`)
};

const ar_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تابع لتصلك أخبار المباريات.`)
};

const ms_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikuti untuk mendapat berita tentang perlawanan.`)
};

const bn_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খেলার খবর পেতে অনুসরণ করুন।`)
};

const zh_tw2_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追蹤後可收到比賽消息。`)
};

const zh_hk2_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追蹤後可收到比賽消息。`)
};

const ur_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`میچوں کی خبر پانے کے لیے فالو کریں۔`)
};

const fa_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برای دریافت خبر بازی‌ها دنبال کنید.`)
};

const sw_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuatilia ili kupata habari za michezo.`)
};

const nl_follow_hint = /** @type {(inputs: Follow_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volg om bericht te krijgen over wedstrijden.`)
};

/**
* | output |
* | --- |
* | "Follow to be notified about games." |
*
* @param {Follow_HintInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const follow_hint = /** @type {((inputs?: Follow_HintInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_HintInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_follow_hint(inputs)
	if (locale === "ja") return ja_follow_hint(inputs)
	if (locale === "zh") return zh_follow_hint(inputs)
	if (locale === "es") return es_follow_hint(inputs)
	if (locale === "pt") return pt_follow_hint(inputs)
	if (locale === "id") return id_follow_hint(inputs)
	if (locale === "fr") return fr_follow_hint(inputs)
	if (locale === "tl") return tl_follow_hint(inputs)
	if (locale === "vi") return vi_follow_hint(inputs)
	if (locale === "ko") return ko_follow_hint(inputs)
	if (locale === "de") return de_follow_hint(inputs)
	if (locale === "ru") return ru_follow_hint(inputs)
	if (locale === "tr") return tr_follow_hint(inputs)
	if (locale === "it") return it_follow_hint(inputs)
	if (locale === "pl") return pl_follow_hint(inputs)
	if (locale === "uk") return uk_follow_hint(inputs)
	if (locale === "hi") return hi_follow_hint(inputs)
	if (locale === "ar") return ar_follow_hint(inputs)
	if (locale === "ms") return ms_follow_hint(inputs)
	if (locale === "bn") return bn_follow_hint(inputs)
	if (locale === "zh-TW") return zh_tw2_follow_hint(inputs)
	if (locale === "zh-HK") return zh_hk2_follow_hint(inputs)
	if (locale === "ur") return ur_follow_hint(inputs)
	if (locale === "fa") return fa_follow_hint(inputs)
	if (locale === "sw") return sw_follow_hint(inputs)
	if (locale === "nl") return nl_follow_hint(inputs)
	return en_follow_hint(inputs)
});